import styled from 'styled-components'
import theme from '../../theme/theme';

export const SearchBarSection = styled.div`
display: flex;
justify-content: center;
align-items: center;
width: 100%;
background-color: ${theme.color.navy};
margin: 0;
position: fixed;
z-index: 900;
top: 80px;
`;

export const IconSection = styled.div`
display: flex;
justify-content: center;
align-items: center;
width: 100%;
height: 110px;
background-color: ${theme.color.white};
margin-bottom: 30px;
position: fixed;
z-index: 900;
top: 155px;
`;

export const CardSection = styled.div`
display: grid;
grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
grid-gap: 20px;
width: 90%;
margin: 20px auto;
align-items: flex-start;
margin-top: 235px;

@media (min-width: 280px) {
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
}

@media (max-width: 1300px) {
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
}
`;

// export const CardSection = styled.div`
// display: grid;
// grid-gap: 5px;
// grid-template-columns: repeat(4, 1fr);
// width: 90%;
// background-color: ${theme.color.white};
// margin: 0 auto 10px;

// @media (max-width: 420px) {
//     grid-template-columns: 1fr;
// }

// @media (min-width: 421px) and (max-width: 940px) {
//     grid-template-columns: repeat(2, 1fr);
// }

// @media (min-width: 941px) and (max-width: 1200px) {
//     grid-template-columns: repeat(3, 1fr);
// }
// `;

export const ResourceCard = styled.div`
display: flex;
flex-direction: column;
align-items: center; 
margin-bottom: 10px;
// text-align: center; 
// padding: 10px;
// background-color: #f2f2f2;
// border: 1px solid #ccc;
`;